import i18n from '../../../../i18n';

interface ScheduleButtonTooltipParams {
  hasPermission: boolean;
  hasCompleted: boolean;
  hasArrivedStop: boolean;
  isGeocoding: boolean;
  isLocked: boolean;
  isScheduling: boolean;
  isUnscheduling: boolean;
  orderAssignedToOnlyRoute: boolean;
  allOrdersAssignedToRoute: boolean;
  allScheduled: boolean;
  ordersLength: number;
}

/**
 * Get the appropriate tooltip text for the schedule button based on current state
 * 
 * @param params - Object containing all relevant state for determining tooltip
 * @returns Translated tooltip text
 */
const getScheduleButtonTooltip = ({
  hasPermission,
  hasCompleted,
  hasArrivedStop,
  isGeocoding,
  isLocked,
  isScheduling,
  isUnscheduling,
  orderAssignedToOnlyRoute,
  allOrdersAssignedToRoute,
  allScheduled,
  ordersLength,
}: ScheduleButtonTooltipParams): string => {
  // Check conditions in priority order
  if (!hasPermission) {
    return i18n.t('components:scheduleButton.tooltips.noPermission', { 
      action: i18n.t('components:scheduleButton.schedule'),
    });
  }

  if (hasCompleted) {
    return i18n.t('components:scheduleButton.tooltips.scheduleCompleted', { count: ordersLength });
  }

  if (hasArrivedStop) {
    return i18n.t('components:scheduleButton.tooltips.arrived', { count: ordersLength });
  }

  if (isGeocoding) {
    return i18n.t('components:multiSelectActionsBar.orders.tooltip.isGeocoding');
  }

  if (isLocked) {
    return i18n.t('components:scheduleButton.tooltips.scheduling');
  }

  if (isScheduling) {
    return i18n.t('components:scheduleButton.tooltips.rescheduling');
  }

  if (isUnscheduling) {
    return i18n.t('components:unscheduleButton.tooltips.unscheduling');
  }

  if (orderAssignedToOnlyRoute || allOrdersAssignedToRoute) {
    return i18n.t('components:scheduleButton.tooltips.oneRoute');
  }

  if (allScheduled) {
    return i18n.t('components:scheduleButton.reschedule');
  }

  return i18n.t('components:scheduleButton.schedule');
};

export default getScheduleButtonTooltip;
